import ProjectUtils from "../../../../../../utils/project-utils.js";
import {makeApplicationsDetailsItems, makeIndividualItems} from "../helpers/applications-details-items.jsx";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

export default function ApplicationsDetails({ data, title, printOptions }) {
    const individual = makeIndividualItems(data, printOptions);
    const application = makeApplicationsDetailsItems(data, printOptions);

    return (
        <div className={printOptions?.showRequesters ? "" : "print:hidden"}>
            <div className="space-y-4 px-5">
                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                    {title}
                </h2>

                <div className="space-y-2">
                    <InfoGrid title="" items={individual} columns={3} className={'px-0!'}/>
                    <InfoGrid title="" items={application} columns={3} className={'px-0!'}/>
                </div>
            </div>
        </div>
    )
}